import React, { createContext, useReducer, useContext } from 'react';
import { getInitRegistryInfo } from './Const';

const RootStateContext = createContext();
const RootDispatchContext = createContext();

const initRegistryState = {
  registryInfo: getInitRegistryInfo(),
  teamsInReview: [],
};

const RegistryReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_REGISTRY_INFO': {
      return {
        ...state,
        registryInfo: payload,
      };
    }
    case 'UPDATE_ATTACHMENTS': {
      return {
        ...state,
        registryInfo: {
          ...state.registryInfo,
          attachments: payload,
        },
      };
    }
    default:
      throw new Error('Invalid action type');
  }
};

const RegistryProvider = ({ children }) => {
  const [state, dispatch] = useReducer(RegistryReducer, initRegistryState);

  return (
    <RootStateContext.Provider value={state}>
      <RootDispatchContext.Provider value={dispatch}>{children}</RootDispatchContext.Provider>
    </RootStateContext.Provider>
  );
};

const useRegistryState = () => {
  const context = useContext(RootStateContext);

  if (context === undefined) {
    throw new Error('useRegistryState must be used within a RegistryProvider');
  }
  return context;
};

const useRegistryDispatch = () => {
  const context = useContext(RootDispatchContext);

  if (context === undefined) {
    throw new Error('useRegistryDispatch must be used within a RegistryProvider');
  }
  return context;
};

export { RegistryProvider, useRegistryState, useRegistryDispatch };
